import React from "react";
import { useI18n } from "../../../i18n/LanguageContext";

const ErrorModal = ({
  isOpen,
  onClose,
  onChange,
  title,
  message,
  details,
  buttonText,
}) => {
  const { t } = useI18n();
  const heading = title || t("error.title");
  const action = buttonText || t("error.ok");
  const handleChange = () => {
    onClose();
    onChange();
  };
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black bg-opacity-50 transition-opacity"
        onClick={handleChange}
      />

      {/* Modal */}
      <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-red-100 bg-red-50 rounded-t-lg">
          <div className="flex items-center space-x-3">
            <div className="flex-shrink-0">
              <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center">
                {/* <XMarkIcon className="w-5 h-5 text-red-600" /> */}
              </div>
            </div>
            <h3 className="text-lg font-semibold text-red-800">{heading}</h3>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            {/* <XMarkIcon className="w-6 h-6" /> */}
          </button>
        </div>

        {/* Body */}
        <div className="p-6 space-y-4">
          <p className="text-gray-700 leading-relaxed">{message}</p>

          {details && (
            <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
              <p className="text-sm text-gray-600 font-mono break-words">
                {details}
              </p>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="flex justify-end p-6 border-t border-gray-200 bg-red-50 rounded-b-lg">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 transition-colors"
          >
            {action}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;
